import type { ToastViewportPreset } from './useToastViewportStore'

export const RIGHT_PANEL_TOAST_VIEWPORT_PRESET: ToastViewportPreset = 'right-panel'
export const RIGHT_PANEL_TOAST_VIEWPORT_PRESET_FLOATING: ToastViewportPreset =
  'right-panel-floating'
